<div class="container">
  <form [formGroup]="user" (ngSubmit)="login()">
    <mat-form-field color="accent">
      <mat-label>User Name</mat-label>
      <input
        required
        matInput
        name="name"
        autocomplete="name"
        formControlName="name"
      />
    </mat-form-field>
    <mat-form-field color="accent">
      <mat-label>User Email</mat-label>
      <input
        required
        matInput
        type="email"
        name="email"
        autocomplete="email"
        formControlName="email"
      />
    </mat-form-field>
    <mat-form-field color="accent">
      <mat-label>Password</mat-label>
      <input
        required
        matInput
        type="password"
        name="password"
        autocomplete="current-password"
        formControlName="password"
      />
    </mat-form-field>

    <button mat-raised-button class="button">Login</button>
  </form>
</div>
